import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import BrcContextWrapper from './BrcContextWrapper.js';
import PostHogContextWrapper from './PostHogContextWrapper.js';

ReactDOM.render(
  <React.StrictMode>
    <PostHogContextWrapper>
      <BrcContextWrapper>
        <App />
      </BrcContextWrapper>
    </PostHogContextWrapper>
  </React.StrictMode>,
  document.getElementById('root')
);
